import { RefObject, useEffect, useCallback } from 'react'

export function useOnClickOutside<E extends Event = MouseEvent | TouchEvent>(
  ref: RefObject<HTMLElement | null>,
  handler: (event: E) => void,
  toggleRef?: RefObject<HTMLElement | null>
) {
  const memoizedHandler = useCallback(handler, [handler])

  useEffect(() => {
    const listener = (event: E) => {
      if (
        !ref.current ||
        ref.current.contains(event.target as Node) ||
        toggleRef?.current?.contains(event.target as Node)
      ) {
        return
      }
      memoizedHandler(event)
    }

    document.addEventListener('mousedown', listener as EventListener)
    document.addEventListener('touchstart', listener as EventListener)

    return () => {
      document.removeEventListener('mousedown', listener as EventListener)
      document.removeEventListener('touchstart', listener as EventListener)
    }
  }, [ref, memoizedHandler, toggleRef])
}
